import { ALL_INSTANCES } from '../Constants/instance.constants';

const initalState = {
    allClients: []
};

export default (state = initalState, action) => {
    switch (action.type) {
        case ALL_INSTANCES:
            return {
                allClients: action.data
            };
        default:
            return state;
    }
};
